import { render, staticRenderFns } from "./KvmDockerAppManage.vue?vue&type=template&id=0f5b4326&scoped=true&"
import script from "./KvmDockerAppManage.vue?vue&type=script&lang=js&"
export * from "./KvmDockerAppManage.vue?vue&type=script&lang=js&"
import style0 from "./KvmDockerAppManage.vue?vue&type=style&index=0&id=0f5b4326&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5b4326",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f5b4326')) {
      api.createRecord('0f5b4326', component.options)
    } else {
      api.reload('0f5b4326', component.options)
    }
    module.hot.accept("./KvmDockerAppManage.vue?vue&type=template&id=0f5b4326&scoped=true&", function () {
      api.rerender('0f5b4326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmDockerAppManage.vue"
export default component.exports